import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class WeatherFactService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'weather-fact';

  list(filter): Observable<Fact|TechError> {
    const station = filter.station ? 'station=' + (filter.station) : '';
    const params = `?${station}`;
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + params;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<Fact|TechError>(uri, {headers: headers});
  }
  cities(): Observable<CityItem[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/cities';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<CityItem[]>(uri, {headers: headers});
  }
  allCities(): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/all-cities';
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
  allCuttedCities(country): Observable<any> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/all-cutted-cities?country='+country;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<any>(uri, {headers: headers});
  }
}
interface Fact {
  d: any,
  t: any,
  w: any, // Относительная влажность (%)
  pStation: any, // Давление на уровне станции
  pSea: any, // Давление на уровне моря
  tend: any, // Тенденция изменения давления за последний час (0 – не изменяется, 1 – растет, 2 - падает)
  code: any, // Код погоды текущий (таблица codew_ams)
  status: string // For ERROR: TechError
}
interface TechError {
  status: string
}
interface CityItem {
  id: number,
  name: string,
  lat: number,
  lng: number
}
